import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Tab from '@mui/material/Tab';
import Tabs from "@mui/material/Tabs";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LicenceCheck from "../../../Authorisation/LicenceCheck";
import { APIContext } from "../../../Contexts/APIContext";
import { ContactFormContext } from "../../../Contexts/ContactFormContext";
import { SessionContext } from "../../../Contexts/SessionContext";
import { SurveyViewModel } from "../../../Contexts/SessionState";
import DeselectedSurveysViewModel from "../../Calculation/DeselectedSurveysViewModel";
import SiteSelectionTab from "../../Calculation/SiteSelectionTab";
import RankOrderPeriodDialog from "../../RankOrderList/RankOrderPeriodDialog";
import ExportViewModel from "../../ViewModels/ExportViewModel";
import TripRateCalculationFiltersViewModel from "../../ViewModels/TripRateCalculationFiltersViewModel";
import TripRateExportViewModel from "../../ViewModels/TripRateExportViewModel";
import ExportSummaryFilterViewModel from "./ExportSummaryFilterViewModel";
import MainSummary from "./MainSummarySection";
import SummaryFilteringExportDialog from "./SummaryFilteringExportDialog";
import SurveySelectionTab from "./SurveySelectionTab";
import { useTripRateContext } from "../../TripRateContext";
import { getFilteredSurveyRefs } from "../../../TripRateNew/TriprateFilters";
import { getValidActiveSurveyRefs } from "../../TripRateSurveyRefs";

export default function TripRateSummary() {
    const { openContactForm } = useContext(ContactFormContext);
    const { sessionState } = useContext(SessionContext);
    const { surveys } = useTripRateContext();
    const selectedSurveyRefs = getValidActiveSurveyRefs(
        sessionState.selectedSitesAndSurveys,
        getFilteredSurveyRefs(surveys),
    );
    const [surveysLoading, setSurveysLoading] = useState<boolean>(false);
    const [rankOrderOpen, setRankOrderOpen] = useState(false);
    const [exportOpen, setExportOpen] = useState(false);
    const [tabIndex, setTabIndex] = useState<number>(0);
    const { postPDF } = useContext(APIContext);
    const { saveSession } = useContext(SessionContext);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('toTab');

    useEffect(() => {
        //get the default tab index for this page
        if (tabParam !== null && tabParam !== '') {
            //HERE
            switch (tabParam) {
                case 'siteSummary':
                    setTabIndex(1);
                    break;
                case 'surveySummary':
                    setTabIndex(2);
                    break;
                default:
                    setTabIndex(0);
                    break;
            }
        }
    }, [tabParam])

    const closeDialogs = (refresh?: boolean) => {
        setRankOrderOpen(false)
        setExportOpen(false)
    }

    const saveSessionForPDF = () => {
        saveSession(`Site_List_${new Date().toISOString()}`, 'audit', data => getReportPDF(new ExportViewModel(), data));
    };

    const getReportPDF = (exportFilters: ExportViewModel, auditCode?: string) => {
        const data = new TripRateExportViewModel()
        var filter: TripRateCalculationFiltersViewModel = {
            tripRateMain: sessionState.tripRateMain,
            tripRateSub: sessionState.tripRateSub,
            primaryFilters: sessionState.primaryFilters,
            secondaryFilters: sessionState.secondaryFilters,
            landUsePage: sessionState.landusePage
        }

        data.filtersVm = filter;
        data.autoRemovedSurveysCountList = sessionState.selectedSitesAndSurveys.filter(f => !f.surveyActive && !f.manuallyRemoved).length;
        data.manuallyRemovedSurveysCount = sessionState.selectedSitesAndSurveys.filter(f => f.manuallyRemoved).length;
        data.selectedSurveys = selectedSurveyRefs;
        data.exportFiltersVm = { ...exportFilters, auditCode: auditCode ?? '' }

        const deselected: DeselectedSurveysViewModel[] = [];

        sessionState.selectedSitesAndSurveys
            .filter(f => !f.siteActive || !f.surveyActive)
            .forEach((item: SurveyViewModel) => {
                deselected.push({
                    reference: item.siteRef,
                    surveyDate: item.surveyRef.split("|")[1],
                    reasonForDeselection: item.reasonForSurveyRemoval == "Removed in Site Selection" ? item.reasonForSiteRemoval : item.reasonForSurveyRemoval,
                    manuallyRemoved: item.manuallyRemoved
                });
            });
        data.exportFiltersVm.deselectedSurveys = deselected;
        const reportTitle = data.exportFiltersVm.reportTitle?.trim();
        postPDF("PDFGenerator", "GetEnhancedSiteList", reportTitle ? reportTitle : "Trip Rate", false, data);
    }

    const sendBureauRequest = (type: 'Bureau' | 'Bureau Rank' | 'Free Trial' | 'Free Trial Rank') => () => {
        switch (type) {
            case 'Bureau':
                openContactForm(
                    'As a member of a Bureau licence this form will send a request to TRICS team to generate your Trip Rate Calculation for you.',
                    'Bureau Trip Rate Request'
                );
                break;
            case 'Bureau Rank':
                openContactForm(
                    'As a member of a Bureau licence this form will send a request to TRICS team to generate your Rank Order List for you.',
                    'Bureau Rank Order Request');
                break;
            case 'Free Trial':
                openContactForm(
                    'As a member of a Free Trial licence this form will send a request to TRICS team for an example Trip Rate Calculation.',
                    'Free Trial Example Trip Rate Request');
                break;
            case 'Free Trial Rank':
                openContactForm(
                    'As a member of a Free Trial licence this form will send a request to TRICS team for an example Rank Order List.',
                    'Free Trial Example Rank Order Request');
                break;
        }
    }


    const getReport = (vm: ExportSummaryFilterViewModel) => {

        const data = new TripRateExportViewModel()
        var filter: TripRateCalculationFiltersViewModel = {
            tripRateMain: sessionState.tripRateMain,
            tripRateSub: sessionState.tripRateSub,
            primaryFilters: sessionState.primaryFilters,
            secondaryFilters: sessionState.secondaryFilters,
            landUsePage: sessionState.landusePage
        }

        data.filtersVm = filter;
        data.autoRemovedSurveysCountList = sessionState.selectedSitesAndSurveys.filter(f => !f.surveyActive && !f.manuallyRemoved).length;
        data.manuallyRemovedSurveysCount = sessionState.selectedSitesAndSurveys.filter(f => f.manuallyRemoved).length;
        data.selectedSurveys = selectedSurveyRefs;
        data.hourly = true
        data.extrapolate = false;
        data.SelectedVehicleType = 0;

        const deselected: DeselectedSurveysViewModel[] = [];

        sessionState.selectedSitesAndSurveys
            .filter(f => !f.siteActive || !f.surveyActive)
            .forEach((item: SurveyViewModel) => {
                deselected.push({
                    reference: item.siteRef,
                    surveyDate: item.surveyRef.split("|")[1],
                    reasonForDeselection: item.reasonForSurveyRemoval == "Removed in Site Selection" ? item.reasonForSiteRemoval : item.reasonForSurveyRemoval,
                    manuallyRemoved: item.manuallyRemoved
                });
            });
        data.exportFiltersVm.deselectedSurveys = deselected;


        vm.selectedSurveys = selectedSurveyRefs;
        var filter: TripRateCalculationFiltersViewModel = {
            tripRateMain: sessionState.tripRateMain,
            tripRateSub: sessionState.tripRateSub,
            primaryFilters: sessionState.primaryFilters,
            secondaryFilters: sessionState.secondaryFilters,
            landUsePage: sessionState.landusePage
        }

        vm.filters = filter;

        vm.tripExport = data;

        vm.mainLandUse = sessionState.tripRateMain;
        vm.subLandUse = sessionState.tripRateSub;
        vm.headerIndex = sessionState.primaryFilters.headerIndex

        postPDF(`PDFGenerator`, `GetTripRateSummaryPDF`, vm.fileName ?? "Trip Rate Summary", vm.displayDirectlyToScreen, vm)
        closeDialogs();
    }

    return (
        <Paper style={{ padding: '5px' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabIndex}
                    onChange={(e, index: number) => setTabIndex(index)}
                    textColor="inherit"
                    indicatorColor="primary">
                    <Tab label="Main Summary" value={0} />
                    <Tab label="Site Selection" value={1} />
                    <Tab label="Survey Selection" value={2} />
                </Tabs>
            </Box>
            <div hidden={tabIndex !== 0}>
                <Grid container size={12} alignItems={'flex-start'}>
                    <Grid size={8}>
                        <MainSummary />
                    </Grid>

                    <Grid component={Paper} size={4}>
                        <Stack spacing={1}>
                            <Button disabled={surveysLoading} onClick={saveSessionForPDF}>Enhanced Site List PDF</Button>
                            <LicenceCheck requriedLicence={['Education', 'Single Office (Unlimited Access)', 'Multi-Office', 'Single Office (Single Access)']}>
                                <Button disabled={surveysLoading} onClick={() => setRankOrderOpen(true)}>Rank Order List</Button>
                                <Button disabled={surveysLoading} onClick={() => setExportOpen(true)}>Export Summary</Button>
                            </LicenceCheck>
                            <LicenceCheck requriedLicence={["Bureau"]}>
                                <Button disabled={surveysLoading} onClick={sendBureauRequest('Bureau Rank')}>Request Rank Order List</Button>
                                <Button disabled={surveysLoading} onClick={sendBureauRequest('Bureau')}>Request Trip Rate Calculation</Button>
                            </LicenceCheck>
                            <LicenceCheck requriedLicence={["Free Trial"]}>
                                <Button disabled={surveysLoading} onClick={sendBureauRequest('Free Trial Rank')}>Request Rank Order List Example</Button>
                                <Button disabled={surveysLoading} onClick={sendBureauRequest('Free Trial')}>Request Trip Rate Calculation Example</Button>
                            </LicenceCheck>
                        </Stack>
                    </Grid>

                    {rankOrderOpen && <RankOrderPeriodDialog dialogOpen={rankOrderOpen} handleClose={closeDialogs} />}
                    {exportOpen && <SummaryFilteringExportDialog dialogOpen={exportOpen} handleClose={closeDialogs} exportSummaryFilters={getReport} />}
                </Grid>
            </div>
            <div hidden={tabIndex !== 1}>
                <SiteSelectionTab />
            </div>
            <div hidden={tabIndex !== 2}>
                <SurveySelectionTab setLoading={setSurveysLoading} />
            </div>
        </Paper >
    )
}
